// extracted by mini-css-extract-plugin
export var btnToggle = "drawer-module--btn-toggle--32kj7";
export var btnToggleIcon = "drawer-module--btn-toggle-icon--WITb9";
export var content = "drawer-module--content--+9xHG";
export var drawer = "drawer-module--drawer--CdiHq";
export var wrapper = "drawer-module--wrapper--S01Rv";